import { useMemo } from 'react';
import { CreateProjectDtoProjectStatusEnum } from '@sib/api';
import { useTranslation } from '@sib/i18n';

interface ProjectStatusOption<T> {
  value: T;
  label: string;
  color: string;
}

export const useProjectStatusOptions = <T extends string>() => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        value: CreateProjectDtoProjectStatusEnum.Active,
        label: t('enums.projectStatus.active'),
        color: 'hsl(var(--success-vivid))',
      },
      {
        value: CreateProjectDtoProjectStatusEnum.Archived,
        label: t('enums.projectStatus.archived'),
        color: 'hsl(var(--neutral-soft))',
      },
      {
        value: CreateProjectDtoProjectStatusEnum.OnHold,
        label: t('enums.projectStatus.onHold'),
        color: 'hsl(var(--warning-vivid))',
      },
    ],
    [t]
  ) as ProjectStatusOption<T>[];
};
